import { createSelector } from '@reduxjs/toolkit';

import { ColorByOption } from '@paragon/contract-library';
import { hasTrussDesignPermission, isLoggedInUserEngineer } from '@paragon/login-tools';
import { DEFAULT_COLOR_BY_OPTIONS } from '@paragon/user-settings';

import { RootState } from '../index';

export const getEnabledColorByOptions = createSelector(
  hasTrussDesignPermission,
  isLoggedInUserEngineer,
  (state: RootState) => state.application.openContext?.type === 'shared-component-set',
  (isTrussDesigner, isEngineer, isViewingSharedComponentSet) => {
    const result: ColorByOption[] = DEFAULT_COLOR_BY_OPTIONS;

    if (isTrussDesigner || isEngineer || isViewingSharedComponentSet) {
      result.unshift('Combined');
    }

    return result;
  },
);
